import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24809b85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-column p-align-center signin-container-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Non hai ancora un profilo? ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Registrati qui")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_GvInputText = _resolveComponent("GvInputText")!
  const _component_GVPassword = _resolveComponent("GVPassword")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!

  return (_openBlock(), _createBlock(_component_GvSpinner, { "is-loading": $setup.isLoading }, {
    default: _withCtx(() => [
      _createVNode(_component_Toast, { position: "top-center" }),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_GvInputText, {
            autocomplete: "on",
            class: "input-text p-mb-2 p-mt-2",
            "data-testid": "email-input",
            "field-name": "Email",
            id: "email",
            modelValue: $setup.v$.email.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v$.email.$model) = $event)),
            errors: $setup.v$.email.$silentErrors,
            "is-dirty": $setup.v$.email.$dirty
          }, null, 8 /* PROPS */, ["modelValue", "errors", "is-dirty"]),
          _createVNode(_component_GVPassword, {
            class: "input-text p-mb-2",
            "data-testid": "password-input",
            "field-name": "Password",
            id: "password",
            autocomplete: "on",
            modelValue: $setup.v$.password.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.v$.password.$model) = $event)),
            type: "password",
            errors: $setup.v$.password.$silentErrors,
            "is-dirty": $setup.v$.password.$dirty
          }, null, 8 /* PROPS */, ["modelValue", "errors", "is-dirty"]),
          _createVNode(_component_Button, {
            "data-testid": "signin-button",
            onClick: $setup.performLogin,
            label: "Log In",
            class: "gv-button login-button p-button p-mb-2",
            disabled: $setup.v$.$invalid
          }, null, 8 /* PROPS */, ["onClick", "disabled"]),
          _createVNode(_component_Button, {
            onClick: $setup.goToResetPassword,
            class: "p-justify-center p-button-link forgot-password-link p-button",
            label: "Password dimenticata?"
          }, null, 8 /* PROPS */, ["onClick"]),
          _createElementVNode("p", null, [
            _hoisted_2,
            _createVNode(_component_router_link, { to: "/signup" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1 /* STABLE */
            })
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-loading"]))
}